import { Component, OnInit } from '@angular/core';
import {CommercialOrganicService} from '../../shared/services/commercial-organic.service';
import {CommercialOrganic} from '../../shared/models/commercial-organic';
import {Title} from '@angular/platform-browser';
import {MessageService} from '../../shared/messages/message.service';
import {environment} from '../../../environments/environment';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-commercial-organic-dashboard',
  templateUrl: './commercial-organic-dashboard.component.html',
  styleUrls: ['./commercial-organic-dashboard.component.css']
})
export class CommercialOrganicDashboardComponent implements OnInit {


  totalRecords: number;
  to: number;
  from: number;
  currentPage: number;
  lastPage: number;
  perPage = '20';
  perPageChanged = false;
  page: string;
  orderColumn = 'id';
  orderDirection = 'desc';
  orderChanged = false;
  ordering = '';
  searchValue = '';


  baseUrl = environment.baseUrl;
  defaultImage = environment.defaultImage;
  errorImage = environment.errorImage;
  loading = true;
  loaded = false;
  error = false;
  commercialOrganic: CommercialOrganic[];
  title: string;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public messageService: MessageService,
    private titleService: Title,
    private commercialOrganicService: CommercialOrganicService,
  ) { }

  ngOnInit(): void {
    // Get page query param
    this.route.queryParams.subscribe(params => {
      // Defaults to 0 if no query param provided.
      this.page = params.page || '1';
      this.searchValue = params.q || '';
      this.perPage = params.limit || '20';
      this.ordering = params.ordering || '#';
      this.setOrdering(this.ordering);
      this.loading = true;
      this.loaded = false;
      this.getNames('Commercial Organic');
    });
  }

  private getAll(title: string) {
    this.titleService.setTitle(title);
    this.title = title;

    // Fetch all commercial organic products
    this.commercialOrganicService.getAll(this.page, this.perPage, this.orderColumn, this.orderDirection).subscribe(response => {
        this.commercialOrganic = response.data;
        this.page = response.meta.page;
        this.currentPage = response.meta.current_page;
        this.lastPage = response.meta.last_page;
        this.from = response.meta.from;
        this.to = response.meta.to;
        this.loading = false;
        this.loaded = true;
        this.error = false;
      },
      error => {
        // Handle error when no commercial organic items are found
        this.messageService.showMessage('info', 'Not found', 'Offshelf organic produucts not found');
        this.loading = false;
        this.error = true;
      });
  }

  private getNames(title: string) {
    this.title = title;
    this.titleService.setTitle(title);

    // Fetch pests, diseases or weeds based on the type
    this.filter(this.page, this.perPage, this.orderColumn, this.orderDirection, this.searchValue);
  }

  private filter(page = '', perPage = '', orderColumn = '', orderDirection = '', searchValue = '') {
    this.commercialOrganicService.getSummaryNames(page, perPage, orderColumn, orderDirection, searchValue).subscribe(response => {
        this.commercialOrganic = response.data;
        this.totalRecords = response.total;
        this.page = response.page;
        this.currentPage = response.current_page;
        this.lastPage = response.last_page;
        this.from = response.from;
        this.to = response.to;
        this.loading = false;
        this.loaded = true;
        this.error = false;
      },
      error => {
        // Error handling
        this.messageService.showMessage('info', 'Not found', this.title + 's not found');
        this.loading = false;
        this.error = true;
      }
    );
  }

// Capitalize the first character of a string
  private capitalize(word: string)  {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }

  public goToPage(page){
    this.loading = true;
    this.loaded = false;
    this.page = page;
    // Load in same page
    // this.filter(this.type, this.page, this.perPage, this.orderColumn, this.orderDirection, this.searchValue);
    // Navigate to page
    this.router.navigateByUrl(`/commercial-organic?page=${page}${this.orderChanged ? '&ordering=' + this.ordering : ''}${this.searchValue !== '' ? '&q=' + this.searchValue : ''}${this.perPage !== '20' ? '&limit=' + this.perPage : ''}`);

  }
  // Handles an item search based on search value
  public search(){
    this.loading = true;
    this.loaded = false;
    this.page = '1';
    this.filter(this.page, this.perPage, this.orderColumn, this.orderDirection, this.searchValue);
  }
  // Handle change in items per pagge to be displayed
  public itemsPerPageChanged(){
    this.loading = true;
    this.loaded = false;
    this.page = '1';
    this.perPageChanged = true;
    this.filter(this.page, this.perPage, this.orderColumn, this.orderDirection, this.searchValue);
  }
  // Handle change in sort order and field
  public sortOrderChanged() {
    const value = this.ordering;
    this.setOrdering(value);
    this.loading = true;
    this.loaded = false;
    this.page = '1';

    this.filter(this.page, this.perPage, this.orderColumn, this.orderDirection, this.searchValue);
  }
  private setOrdering(value){
    if (value.indexOf('!') === 0) {
      this.orderColumn = value.substring(1, value.length);
      this.orderDirection = 'desc';
      this.orderChanged = true;
    } else if (value === '#'){
      // Default Ordering
      this.orderColumn = 'id';
      this.orderDirection = 'desc';
      this.orderChanged = false;
    } else {
      this.orderColumn = value;
      this.orderDirection = 'asc';
      this.orderChanged = true;
    }
  }
}
